import { getRequiredParams } from './getRequiredParams';
import { isLocalhost } from './isLocalhost';
export function getIdentityProviderUrl(idpId) {
  const params = getRequiredParams();
  const origin = isLocalhost() ? 'https://id-dev.iam.sbercloud.dev' : location.origin;
  const loginPath = `/auth/system/idp/${idpId}/login${params.tab ? `?${new URLSearchParams(params).toString()}` : ''}`;
  return `${origin}${loginPath}`;
}